import React, { Component } from 'react';

export default class InstantMutation extends Component {
  componentDidMount() {
    let { mutation } = this.props;

    mutation && mutation();
  }
  render() {
    let { children, mutation, ...props } = this.props;

    return <div {...props}>{children}</div>;
  }
}
